export default __webpack_public_path__ + "static/media/pte_5.9c547033.png";